import { useCountDown } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import './index.scss';

interface EfCountDownProps {
    /**
     * 剩余时间
     */
    leftTime?: number | null;
    /**
     * 左侧提示语文案
     */
    leftTips?: string;
    /**
     * 结束时间
     *
     * 2024-08-31 23:00:00 GMT+8
     *
     * 1725116400000
     */
    endTime?: string | number;
    /**
     * 单位(天)
     */
    tipsDay?: string;
    /**
     * 单位(时)
     */
    tipsHour?: string;
    /**
     * 单位(分)
     */
    tipsMinute?: string;
    /**
     * 单位(秒)
     */
    tipsSecond?: string;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 倒计时
 */
const EfCountDown: React.FC<EfCountDownProps> = ({
    leftTime,
    leftTips,
    endTime,
    tipsDay = ':',
    tipsHour = ':',
    tipsMinute = ':',
    tipsSecond = '',
    className,
}) => {
    const prefixCls = `ef-count-down`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const endTime2 = endTime ? new Date(endTime).getTime() : 0;
    const timerA: any = { targetDate: endTime2 };
    // 是否传入剩余时间
    if (leftTime) {
        timerA.leftTime = leftTime;
    }
    const [_countdown, formattedRes] = useCountDown(timerA);
    const [isClient, setIsClient] = useState(false); // 不加这个的话,会出现水合

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <div className={classes}>
            {leftTips && <div className={`${prefixCls}-tips`}>{leftTips}</div>}
            {isClient && (
                <div className={`${prefixCls}-in`}>
                    <span className={`${prefixCls}-text1`}>{String(formattedRes.days).padStart(2, '0')}</span>
                    <span className={`${prefixCls}-text2`}>{tipsDay}</span>
                    <span className={`${prefixCls}-text1`}>{String(formattedRes.hours).padStart(2, '0')}</span>
                    <span className={`${prefixCls}-text2`}>{tipsHour}</span>
                    <span className={`${prefixCls}-text1`}>{String(formattedRes.minutes).padStart(2, '0')}</span>
                    <span className={`${prefixCls}-text2`}>{tipsMinute}</span>
                    <span className={`${prefixCls}-text1`}>{String(formattedRes.seconds).padStart(2, '0')}</span>
                    <span className={`${prefixCls}-text2`}>{tipsSecond}</span>
                </div>
            )}
        </div>
    );
};

export default EfCountDown;
